/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAudienceConditionGroupPayloadFromJSON, ApiAudienceConditionGroupPayloadToJSON, } from './ApiAudienceConditionGroupPayload';
export function ApiAudiencePayloadFromJSON(json) {
    return ApiAudiencePayloadFromJSONTyped(json, false);
}
export function ApiAudiencePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditionGroups': !exists(json, 'conditionGroups') ? undefined : (json['conditionGroups'].map(ApiAudienceConditionGroupPayloadFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiAudiencePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditionGroups': value.conditionGroups === undefined ? undefined : (value.conditionGroups.map(ApiAudienceConditionGroupPayloadToJSON)),
        'description': value.description,
        'name': value.name,
    };
}
